<script setup>
// assets
import telegramIcon from "@/assets/icons/telegram.svg";
import viberIcon from "@/assets/icons/viber.svg";

const SUPPORT_LINKS = {
    telegram: "https://t.me/echat_support_bot",
    viber: "viber://pa?chatURI=echat",
};
</script>

<template>
    <slot name="header_close"/>

    <div class="wrapper_dialog">
        <h3 class="title">{{ $t("dialog.another_payment.title") }}</h3>

        <div class="content">
            <p class="confirm">{{ $t("dialog.another_payment.text") }}</p>

            <div class="pay-links">
                <a
                    class="pay-link pay-link--telegram"
                    :href="SUPPORT_LINKS.telegram"
                    target="_blank"
                    rel="noopener"
                >
                    <img :src="telegramIcon" alt="telegram"/>
                    Telegram
                </a>

                <a
                    class="pay-link pay-link--viber"
                    :href="SUPPORT_LINKS.viber"
                    target="_blank"
                    rel="noopener"
                >
                    <img :src="viberIcon" alt="viber"/>
                    Viber
                </a>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@use "@/styles/dialog-form.scss";

.pay-links {
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    justify-content: center;
}

.pay-link {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    width: 160px;
    height: 40px;
    padding: 0 16px;

    border: 1px solid var(--svc);
    border-radius: 9px;
    background: #ffffff;
    color: var(--svc) !important;
    text-decoration: none;
    cursor: pointer;
    transition: 0.25s;

    font-family: Gilroy, sans-serif;
    font-size: 14px;
    font-weight: 600;
    line-height: 17px;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    white-space: nowrap;

    img {
        width: 20px;
        height: 20px;
    }

    &:hover {
        background: var(--svc);
        color: #ffffff !important;
    }

    &--telegram {
        --svc: var(--telegram-color);
    }

    &--viber {
        --svc: var(--viber-color);
    }
}
</style>
